import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/useStore';
import { useTheme } from './hooks/useTheme';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import PublicLanding from './pages/PublicLanding';
import PublicPostDetail from './pages/PublicPostDetail';
import PublicUserProfile from './pages/PublicUserProfile';
import Buy from './pages/Buy';
import PurchaseSuccess from './pages/PurchaseSuccess';
import Download from './pages/Download';

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  // Applies the .dark class to <html>
  useTheme();

  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: '1px solid var(--ink)',
            background: 'var(--paper)',
            color: 'var(--ink)',
            fontFamily: 'var(--font-mono)',
            fontSize: '12px',
            boxShadow: 'none',
            maxWidth: '28rem',
          },
        }}
      />
      <Routes>
        {/* Public landing page */}
        <Route path="/" element={<PublicLanding />} />
        {/* Public collaborative post view */}
        <Route path="/post/:id" element={<PublicPostDetail />} />
        {/* Public user profile */}
        <Route path="/u/:username" element={<PublicUserProfile />} />
        {/* Purchase/License routes (public) */}
        <Route path="/buy" element={<Buy />} />
        <Route path="/purchase/success" element={<PurchaseSuccess />} />
        <Route path="/purchase/cancel" element={<Buy />} />
        <Route path="/download/:key" element={<Download />} />
        {/* Auth routes: a signed-in user lands on the reader */}
        <Route
          path="/login"
          element={!isAuthenticated ? <Login /> : <Navigate to="/read" />}
        />
        <Route
          path="/register"
          element={!isAuthenticated ? <Register /> : <Navigate to="/read" />}
        />
        <Route
          path="/forgot-password"
          element={!isAuthenticated ? <ForgotPassword /> : <Navigate to="/read" />}
        />
        <Route
          path="/reset-password"
          element={!isAuthenticated ? <ResetPassword /> : <Navigate to="/read" />}
        />
        {/* Protected routes */}
        <Route
          path="/*"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
